import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const FAQ = () => {
    const { t } = useLanguage();
    const [openIndex, setOpenIndex] = useState(0);

    const faqs = [
        {
            question: t('faq.list.q1.q'),
            answer: t('faq.list.q1.a')
        },
        {
            question: t('faq.list.q2.q'),
            answer: t('faq.list.q2.a')
        },
        {
            question: t('faq.list.q3.q'),
            answer: t('faq.list.q3.a')
        },
        {
            question: t('faq.list.q4.q'),
            answer: t('faq.list.q4.a')
        },
        {
            question: t('faq.list.q5.q'),
            answer: t('faq.list.q5.a')
        },
        {
            question: t('faq.list.q6.q'),
            answer: t('faq.list.q6.a')
        },
        {
            question: t('faq.list.q7.q'),
            answer: t('faq.list.q7.a')
        },
        {
            question: t('faq.list.q8.q'),
            answer: t('faq.list.q8.a')
        },
    ];

    const styles = {
        section: {
            padding: '100px 32px',
            backgroundColor: '#FFFFFF',
        },
        container: {
            maxWidth: '960px',
            margin: '0 auto',
        },
        header: {
            textAlign: 'center',
            marginBottom: '60px',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '16px',
            color: '#2B2B2B',
        },
        highlight: {
            color: '#3457D5',
        },
        subtext: {
            fontSize: '18px',
            color: '#6E6E6E',
            lineHeight: '1.7',
        },
        faqList: {
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
        },
        faqItem: {
            backgroundColor: '#FFFFFF',
            padding: '24px',
            borderRadius: '20px',
            border: '1px solid #E5E5E5',
            boxShadow: '0 18px 36px rgba(15,15,35,0.08)',
            transition: 'all 0.3s',
        },
        questionButton: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            textAlign: 'left',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            gap: '16px',
        },
        question: {
            fontSize: '20px',
            fontWeight: '600',
            color: '#2B2B2B',
        },
        toggleIcon: {
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: 'rgba(52,87,213,0.1)',
            color: '#3457D5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            flexShrink: 0,
        },
        answer: {
            fontSize: '16px',
            color: '#6E6E6E',
            lineHeight: '1.7',
            transition: 'all 0.3s',
            overflow: 'hidden',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
        styles.question.fontSize = '18px';
        styles.faqItem.padding = '20px';
    }

    return (
        <section style={styles.section} id="faq">
            <div style={styles.container}>
                <div style={styles.header}>
                    <h2 style={styles.h2}>
                        {t('faq.title')}<span style={styles.highlight}>{t('faq.titleHighlight')}</span>
                    </h2>
                    <p style={styles.subtext}>
                        {t('faq.subtext')}
                    </p>
                </div>

                <div style={styles.faqList}>
                    {faqs.map((faq, index) => {
                        const isOpen = openIndex === index;
                        return (
                            <div
                                key={index}
                                style={styles.faqItem}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <button
                                    style={styles.questionButton}
                                    onClick={() => setOpenIndex(isOpen ? null : index)}
                                >
                                    <span style={styles.question}>{faq.question}</span>
                                    <span style={styles.toggleIcon}>
                                        {isOpen ? '−' : '+'}
                                    </span>
                                </button>
                                <div
                                    style={{
                                        ...styles.answer,
                                        maxHeight: isOpen ? '500px' : '0',
                                        marginTop: isOpen ? '16px' : '0',
                                        opacity: isOpen ? 1 : 0,
                                    }}
                                >
                                    {faq.answer}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
